import { render, staticRenderFns } from "./SizeSelectorAntV.vue?vue&type=template&id=4c7facca&scoped=true"
import script from "./SizeSelectorAntV.vue?vue&type=script&lang=js"
export * from "./SizeSelectorAntV.vue?vue&type=script&lang=js"
import style0 from "./SizeSelectorAntV.vue?vue&type=style&index=0&id=4c7facca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7facca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7facca')) {
      api.createRecord('4c7facca', component.options)
    } else {
      api.reload('4c7facca', component.options)
    }
    module.hot.accept("./SizeSelectorAntV.vue?vue&type=template&id=4c7facca&scoped=true", function () {
      api.rerender('4c7facca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/shapeAttr/SizeSelectorAntV.vue"
export default component.exports